import { point } from '@turf/helpers'
import { default as pointDistance } from '@turf/distance'
//import { MercatorCoordinate } from 'maplibre-gl/dist/maplibre-gl'

//export const getMaxBounds = (container, padding, bounds) => {
  //const size = {
    //width: container.current.clientWidth,
    //height: container.current.clientHeight
  //}
  //const mw = size.width - padding.left - padding.right
  //const mh = size.height - padding.top - padding.bottom
  //const p1 = MercatorCoordinate.fromLngLat([bounds[0], bounds[1]], 0)
  //const p2 = MercatorCoordinate.fromLngLat([bounds[0], bounds[3]], 0)
  //const p3 = MercatorCoordinate.fromLngLat([bounds[2], bounds[1]], 0)
  //const p4 = MercatorCoordinate.fromLngLat([bounds[2], bounds[3]], 0)
  //const center = p3.x - p1.x 



//}


export const getBestFitBearing = (container, padding, bounds, startPlace) => {
  const size = {
    width: container.current.clientWidth,
    height: container.current.clientHeight
  }
  const p1 = point([bounds[0], bounds[1]])
  const p2 = point([bounds[0], bounds[3]])
  const p3 = point([bounds[2], bounds[1]])
  const p4 = point([bounds[2], bounds[3]])
  const dy = pointDistance(p1, p2)
  const dx = pointDistance(p1, p3)
  const mw = size.width - padding.left - padding.right
  const mh = size.height - padding.top - padding.bottom
  const extendIsLandscape = dx > dy
  const mapIsLandscape = mw > mh
  let bearing = 0

  if (startPlace) {
    const startPoint = point(startPlace)
    const distanceLeft = pointDistance(startPoint, p1) + pointDistance(startPoint, p2)
    const distanceRight = pointDistance(startPoint, p3) + pointDistance(startPoint, p4)
    const distanceTop = pointDistance(startPoint, p1) + pointDistance(startPoint, p4)
    const distanceBottom = pointDistance(startPoint, p2) + pointDistance(startPoint, p4)
    if (distanceRight < distanceLeft) {
      if (distanceBottom < distanceTop) {
        if (mapIsLandscape === extendIsLandscape) {
          bearing = 180
        } else {
          bearing = 90
        }
      } else {
        bearing += 180
        if (mapIsLandscape !== extendIsLandscape) {
          bearing -= 90
        }
      }
    }
    return bearing
  } else {
    if (mapIsLandscape === extendIsLandscape) {
      return bearing
    } else {
      return bearing - 90
    }
  }
}

export const getView = (map) => {
  const center = map.getCenter()
  const zoom = map.getZoom()
  const bearing = map.getBearing()
  const round = Math.pow(10, Math.min(6, Math.max(1, 7 - (16 - Math.round(zoom)))))
  return [center.lng, center.lat, zoom, bearing].map(x => Math.round((x + Number.EPSILON) * round) / round).join('/')
}

export const getViewFromHash = (hash) => hash.substring(1).split('/').map(parseFloat)

export const mapHash = /#[+-]?([0-9]*[.])?[0-9]+\/[+-]?([0-9]*[.])?[0-9]+\/[+-]?([0-9]*[.])?[0-9]+\/?[+-]?([0-9]*[.])?[0-9]+\/?[+-]?([0-9]*[.])?[0-9]+/
